import styled from 'styled-components'
import { SIZES } from '../../../../../constants'
import SearchInput from '../StyledSearchInput'

export default styled(SearchInput)`
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    background: #fff url(${STATICS_PATH}images/search/google.png) calc(100% - 8px) 10px / 110px 19px no-repeat;

    &:focus {
      background: #fff;
    }
  }
`
